<template>
  <TableRegular
    :is-report="true"
    :loading="loading"
    :rows="rows"
    :columns="columns"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :line-numbers="lineNumbers"
    :custom-filters="customFilters"
    :downloadable="downloadable"
    :downloading="downloading"
    @onFilter="$emit('onFilter', $event)"
    @onPageChange="$emit('onPageChange', $event)"
    @onPerPageChange="$emit('onPerPageChange', $event)"
    @onSortChange="$emit('onSortChange', $event)"
    @onChangeCustomFilter="$emit('onChangeCustomFilter', $event)"
    @onDownload="$emit('onDownload')"
  >
    <template slot="before-table-header">
      <tr v-if="$route.name === 'ReportEndDay'">
        <th></th>
        <th colspan="5">
          Банк
        </th>
        <th colspan="4">
          Систем
        </th>
        <th colspan="2"></th>
      </tr>
      <tr v-else>
        <th></th>
        <th colspan="4">
          Банк
        </th>
        <th colspan="4">
          Систем
        </th>
        <th colspan="2">
          Олголт задаргаа
        </th>
        <th colspan="5">
          Төлөлт задаргаа
        </th>
      </tr>
    </template>
    <template slot="table-row" slot-scope="props">
      <p v-if="props.column.field === 'endDate'" class="whitespace-nowrap">
        {{ props.row.endDate }}
      </p>
      <template v-else-if="props.column.field === 'bankIncome'">
        {{ props.row.bankIncome | currency }}
      </template>
      <template v-else-if="props.column.field === 'bankExpense'">
        {{ props.row.bankExpense | currency }}
      </template>
      <template v-else-if="props.column.field === 'totalLoanIssuedAmount'">
        {{ props.row.totalLoanIssuedAmount | currency }}
      </template>
      <template v-else-if="props.column.field === 'totalLoanPaidAmount'">
        {{ props.row.totalLoanPaidAmount | currency }}
      </template>
      <template v-else-if="props.column.field === 'extendedFeeIncome'">
        {{ props.row.extendedFeeIncome | currency }}
      </template>
      <template v-else-if="props.column.field === 'increaseInterestIncome'">
        {{ props.row.increaseInterestIncome | currency }}
      </template>
      <template v-else-if="props.column.field === 'interestIncome'">
        {{ props.row.interestIncome | currency }}
      </template>
      <template v-else-if="props.column.field === 'overPayment'">
        {{ props.row.overPayment | currency }}
      </template>
      <template v-else-if="props.column.field === 'feeIncome'">
        {{ props.row.feeIncome | currency }}
      </template>
      <template v-else-if="props.column.field === 'uTulult'">
        {{ getUTulult(props.row) | currency }}
      </template>
      <div v-else-if="props.column.field === 'action'" class="flex justify-end items-center">
        <Button
          :loading="isLoadingChangeStatus && props.row.id === changingItemId"
          @click="$emit('onChange', props.row.id)"
          class="button text-white bg-theme-9 mr-2"
        >
          <CheckIcon class="w-4 h-4" />
        </Button>
        <Button
          :loading="isLoadingReChangeStatus && props.row.id === changingItemId"
          @click="$emit('onReChange', props.row.id)"
          class="button text-white bg-theme-11"
        >
          <CircleIcon class="w-4 h-4" />
        </Button>
      </div>
    </template>
  </TableRegular>
</template>

<script>
import TableRegular from '@/components/ui/table/TableRegular';
import tableMixin from '@/mixins/tableMixin';
import Button from '@/components/ui/button/Button';

export default {
  mixins: [tableMixin],

  props: {
    isLoadingChangeStatus: Boolean,
    isLoadingReChangeStatus: Boolean,
    changingItemId: {
      type: Number,
      default: null,
    },
  },

  methods: {
    getUTulult(row) {
      const {
        totalLoanPaidAmount,
        extendedFeeIncome,
        increaseInterestIncome,
        interestIncome,
        overPayment,
      } = row;
      return (
        totalLoanPaidAmount -
        extendedFeeIncome -
        increaseInterestIncome -
        interestIncome -
        overPayment
      );
    },
  },

  components: {
    TableRegular,
    Button,
  },
};
</script>
